import { Controller } from "stimulus"

export default class extends Controller {
	connect() {
		// Not sure if we need a promise here or not to make sure that the main menu controller (which sets window.isMobile) has run before this.
		// It currently works fine without the promise (which also feels like a bit of a hack) but guess rather safe than sorry!
		// See https://github.com/hotwired/stimulus/issues/201#issuecomment-435285227
		// and https://stimulus.hotwired.dev/reference/controllers#cross-controller-coordination-with-events
		Promise.resolve().then(() => { if(!window.isMobile) { this.element.focus(); } })
		// TW-TODO: Check if we have the desired behaviour on Android when creating/editing notes/todos etc. If not, this could be adapted to also _remove_ the autofocus attribute when on mobile
	}
}